import styled from '@emotion/styled';
import { SkeletonLoader } from '~/shared/components/SkeletonLoader';
import { breakpoints } from '~/theme';
import { CardContainer } from './Details/styles';
import { CardBottomItem } from './CardBottom';

export default function OrderDetailsSkeleton() {
    return (
        <Section>
            <HeaderSkeleton>
                <HeaderTitle>
                    <SkeletonLoader height={38} isFullWidth />
                </HeaderTitle>
                <DownloadButtonSkeleton>
                    <SkeletonLoader height={38} isFullWidth />
                </DownloadButtonSkeleton>
            </HeaderSkeleton>
            <OrderDetailsContainer>
                {Array.from({ length: 8 }).map((_, index) => (
                    <OrderDetails key={index}>
                        <SkeletonLoader width={60} height={14} />
                        <SkeletonLoader width={50} height={14} />
                        <SkeletonSpacer />
                    </OrderDetails>
                ))}
            </OrderDetailsContainer>
            <CardContainer>
                <SkeletonLoader width={200} height={24} style={{ marginBottom: 5 }} />
                <>
                    {Array.from({ length: 3 }).map((_, index) => (
                        <div key={index}>
                            <SkeletonLoader isFullWidth height={125} />
                            <SkeletonSpacer />
                        </div>
                    ))}
                </>
                <SkeletonBottom>
                    <CardBottomItem>
                        <SkeletonLoader height={14} width={60} />
                        <SkeletonLoader height={14} width={60} style={{ gridColumn: 3 }} />
                    </CardBottomItem>
                    <CardBottomItem>
                        <SkeletonLoader height={14} width={60} />
                        <SkeletonLoader height={14} width={60} style={{ gridColumn: 3 }} />
                    </CardBottomItem>
                    <CardBottomItem>
                        <SkeletonLoader height={14} width={60} />
                        <SkeletonLoader height={14} width={60} style={{ gridColumn: 3 }} />
                    </CardBottomItem>
                </SkeletonBottom>
            </CardContainer>
        </Section>
    );
}
const Section = styled.div(({ theme }) => ({
    display: 'grid',
    gap: theme.space[3],
}));

const HeaderSkeleton = styled.div(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gap: theme.space[3],
}));

const HeaderTitle = styled.span((props) => ({
    position: 'relative',
    gridColumn: '1 / span 3',

    [breakpoints.sm]: {
        gridColumn: '1 / span 2',
    },
}));

const DownloadButtonSkeleton = styled.span((props) => ({
    position: 'relative',
    gridColumn: '9 / span 4',
    display: 'grid',
    alignItems: 'end',

    [breakpoints.md]: {
        gridColumn: '11 / span 2',
    },
}));

const OrderDetailsContainer = styled.div(() => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    rowGap: 24,
    paddingTop: 24,
    marginBottom: 25,
    [breakpoints.sm]: {
        marginBottom: 64,
        gridTemplateColumns: 'repeat(4, 1fr)',
    },
}));

const OrderDetails = styled.span(({ theme }) => ({
    display: 'grid',
    gridTemplateRows: 'repeat(2, 1fr)',
    gap: theme.space[1],
}));

const SkeletonBottom = styled.div(({ theme }) => ({
    display: 'grid',
    padding: theme.space[3],
    height: 130,
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: theme.space[1],
}));

const SkeletonSpacer = styled.div(() => ({
    height: 2,
}));
